// PGCET MCA Mock 5 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "The sum of the first 20 terms of the arithmetic progression 7, 11, 15, … is",
    options: ["A. 860", "B. 900", "C. 940", "D. 880"],
    answer: "B"
  },
  {
    id: 2,
    question: "Given log₁₀ 2 = 0.3010 and log₁₀ 3 = 0.4771, the value of log₁₀ 72 is",
    options: ["A. 1.8572", "B. 1.7781", "C. 1.9031", "D. 1.8062"],
    answer: "A"
  },
  {
    id: 3,
    question: "A set has 6 elements. The number of its subsets that contain at least 2 elements is",
    options: ["A. 63", "B. 56", "C. 57", "D. 58"],
    answer: "C"
  },
  {
    id: 4,
    question: "If α and β are the roots of 2x² − 7x + 3 = 0, then 1/α + 1/β equals",
    options: ["A. 3/7", "B. 7/2", "C. 2/3", "D. 7/3"],
    answer: "D"
  },
  {
    id: 5,
    question: "The value of i + i² + i³ + … + i¹⁰², where i = √−1, is",
    options: ["A. i", "B. −1", "C. −1 + i", "D. 0"],
    answer: "C"
  },
  {
    id: 6,
    question: "The principal argument of the complex number −1 + √3 i is",
    options: ["A. π/3", "B. 2π/3", "C. −π/3", "D. 5π/6"],
    answer: "B"
  },
  {
    id: 7,
    question: "The 3rd term of a geometric progression is 12 and its 6th term is 96. The first term is",
    options: ["A. 3", "B. 4", "C. 2", "D. 6"],
    answer: "A"
  },
  {
    id: 8,
    question: "The number of symmetric relations that can be defined on a set with 3 elements is",
    options: ["A. 512", "B. 8", "C. 32", "D. 64"],
    answer: "D"
  },
  {
    id: 9,
    question: "In how many ways can 4 players be selected from 10 players if 2 particular players must always be included?",
    options: ["A. 56", "B. 70", "C. 45", "D. 28"],
    answer: "D"
  },
  {
    id: 10,
    question: "The number of diagonals of a polygon with 12 sides is",
    options: ["A. 66", "B. 54", "C. 60", "D. 48"],
    answer: "B"
  },
  {
    id: 11,
    question: "The middle term in the expansion of (x + 1/x)¹⁰ is",
    options: ["A. 252", "B. 210", "C. 120", "D. 462"],
    answer: "A"
  },
  {
    id: 12,
    question: "If A = [[2, 3], [1, 4]], then A² − 6A + 5I equals",
    options: ["A. I", "B. A", "C. O (the null matrix)", "D. 5I"],
    answer: "C"
  },
  {
    id: 13,
    question: "The solution of the system x + y + z = 6, x − y + z = 2, 2x + y − z = 1 is (x, y, z) =",
    options: ["A. (2, 1, 3)", "B. (3, 2, 1)", "C. (1, 2, 3)", "D. (1, 3, 2)"],
    answer: "C"
  },
  {
    id: 14,
    question: "The value of the determinant |[1, a, a²], [1, b, b²], [1, c, c²]| is",
    options: [
      "A. (a + b)(b + c)(c + a)",
      "B. (a − b)(b − c)(a − c)",
      "C. abc(a − b)(b − c)(c − a)",
      "D. (a − b)(b − c)(c − a)"
    ],
    answer: "D"
  },
  {
    id: 15,
    question: "The value of lim (x → ∞) of (1 + 3/x)²ˣ is",
    options: ["A. e³", "B. e⁶", "C. e^(3/2)", "D. e²"],
    answer: "B"
  },
  {
    id: 16,
    question: "The value of lim (x → 1) of (x⁴ − 1)/(x − 1) is",
    options: ["A. 4", "B. 1", "C. 0", "D. 3"],
    answer: "A"
  },
  {
    id: 17,
    question: "If y = tan⁻¹(2x/(1 − x²)) for |x| < 1, then dy/dx equals",
    options: ["A. 1/(1 + x²)", "B. 2/(1 + x²)", "C. 2/(1 − x²)", "D. −2/(1 + x²)"],
    answer: "B"
  },
  {
    id: 18,
    question: "The radius of a circle is increasing at the rate of 0.5 cm/s. The rate at which its area is increasing when the radius is 10 cm is",
    options: ["A. 5π cm²/s", "B. 20π cm²/s", "C. 10π cm²/s", "D. π cm²/s"],
    answer: "C"
  },
  {
    id: 19,
    question: "The equation of the tangent to the curve y = x² − 3x + 2 at the point (3, 2) is",
    options: ["A. y = 3x − 7", "B. y = 3x + 7", "C. y = 2x − 4", "D. y = 3x − 9"],
    answer: "A"
  },
  {
    id: 20,
    question: "The value of the integral ∫ x cos x dx from 0 to π/2 is",
    options: ["A. π/2", "B. 1", "C. π/2 + 1", "D. π/2 − 1"],
    answer: "D"
  },
  {
    id: 21,
    question: "∫ dx / (x² + 4x + 13) equals (k is the constant of integration)",
    options: [
      "A. tan⁻¹((x + 2)/3) + k",
      "B. (1/2) tan⁻¹((x + 3)/2) + k",
      "C. (1/3) tan⁻¹((x − 2)/3) + k",
      "D. (1/3) tan⁻¹((x + 2)/3) + k"
    ],
    answer: "D"
  },
  {
    id: 22,
    question: "The value of the integral ∫ x²(1 − x)³ dx from 0 to 1 is",
    options: ["A. 1/30", "B. 1/60", "C. 1/120", "D. 1/20"],
    answer: "B"
  },
  {
    id: 23,
    question: "The integrating factor of the differential equation dy/dx + (2/x) y = x (x > 0) is",
    options: ["A. eˣ", "B. 2x", "C. x²", "D. log x"],
    answer: "C"
  },
  {
    id: 24,
    question: "The area of the triangle with vertices (1, 2), (4, 6) and (7, 2) is",
    options: ["A. 12 sq. units", "B. 24 sq. units", "C. 10 sq. units", "D. 18 sq. units"],
    answer: "A"
  },
  {
    id: 25,
    question: "The point that divides the line segment joining (2, −3) and (8, 9) internally in the ratio 2 : 1 is",
    options: ["A. (4, 1)", "B. (6, 5)", "C. (5, 3)", "D. (6, 3)"],
    answer: "B"
  },
  {
    id: 26,
    question: "The equation of the circle passing through the points (0, 0), (4, 0) and (0, 6) is",
    options: [
      "A. x² + y² + 4x + 6y = 0",
      "B. x² + y² − 6x − 4y = 0",
      "C. x² + y² − 4x + 6y = 0",
      "D. x² + y² − 4x − 6y = 0"
    ],
    answer: "D"
  },
  {
    id: 27,
    question: "The length of the latus rectum of the ellipse x²/25 + y²/16 = 1 is",
    options: ["A. 32/5", "B. 25/2", "C. 16/5", "D. 8/5"],
    answer: "A"
  },
  {
    id: 28,
    question: "If sin θ + cos θ = 7/5 and 0 < θ < π/2, then sin 2θ equals",
    options: ["A. 12/25", "B. 7/25", "C. 24/25", "D. 1"],
    answer: "C"
  },
  {
    id: 29,
    question: "The area of the parallelogram whose adjacent sides are a = 3i + j − 2k and b = i − 3j + 4k is",
    options: ["A. 10√3 sq. units", "B. 5√3 sq. units", "C. 20 sq. units", "D. 10√2 sq. units"],
    answer: "A"
  },
  {
    id: 30,
    question: "A and B are independent events with P(A) = 0.3 and P(B) = 0.4. Then P(A ∪ B) is",
    options: ["A. 0.70", "B. 0.12", "C. 0.58", "D. 0.62"],
    answer: "C"
  }
];

export default pgcetmcaMathematics;
